<ng-container [ngSwitch]="true">
	<ng-container *ngSwitchCase="jurisdiction === 'COGA'">
		<i
			class="obg-m-kyc-notification-icon"
			test-id="persistent-notification"
			[ngClass]="plus18 ? 'ico-over18' : 'ico-exclamation-light'"
		></i>

		<label
			class="obg-m-kyc-notification-label"
			[innerHTML]="notificationData?.message | jurisdiction | translate: notificationData?.interpolateParams"
		>
		</label>

		<a
			class="obg-m-kyc-notification-button"
			test-id="persistent-notification-button"
			*ngIf="!hideVerifyButton"
			[obgInteraction]="verifyTrackingData"
			(click)="triggerActionOrNavigate(notificationData?.destination)"
			>{{ notificationData?.linkText | jurisdiction | translate }}
		</a>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<i
			class="obg-m-kyc-notification-icon"
			test-id="persistent-notification"
			[ngClass]="plus18 ? 'ico-over18' : 'ico-exclamation'"
		>
		</i>

		<label
			class="obg-m-kyc-notification-label"
			[innerHTML]="notificationData?.message | jurisdiction | translate: notificationData?.interpolateParams"
		></label>

		<a
			class="obg-m-kyc-notification-hyperlink mat-stroked-button"
			test-id="persistent-notification-button"
			*ngIf="!hideVerifyButton"
			[obgInteraction]="verifyTrackingData"
			(click)="triggerActionOrNavigate(notificationData?.destination)"
			>{{ notificationData?.linkText | jurisdiction | translate }}
		</a>
	</ng-container>
</ng-container>
